import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Dropdown, Badge } from 'react-bootstrap';
import { faPlus, faXmark, faUpload, faPaperclip, faDownload, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import edit from "../../../../assets/images/edit.png";
import Docmnt from '../../../../assets/images/google-docs.png';
import Export from "../../../../assets/images/export.svg";
import Arcv from "../../../../assets/images/archive.svg";
import { Tab, Tabs, Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import XLSFILE from '../../../../assets/template.xls'
import Rapdf from "../../../../assets/images/pdf.png";
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import GalleryView from './Common/GalleryView.js';

import greencheck from "../../../../assets/images/green_check.png";
import greycheck from "../../../../assets/images/grey_check.png";
import orangecheck from "../../../../assets/images/orange_check.png";
import screeninggreen from "../../../../assets/images/screening_green.png";
import screeninggrey from "../../../../assets/images/screening_grey.png";
import securitygreen from "../../../../assets/images/security_green.png";
import securityred from "../../../../assets/images/security_red.png";
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const OutBound = () => {

  const isMounted = useRef(false);
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [damageType, setDamageType] = useState([]);
  const [totalRows, setTotalRows] = useState({});
  const [totalRowsR, setTotalRowsR] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [activeTab, setActiveTab] = useState('Active');
  const [modalContent, setModalContent] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalRadioValue, setModalRadioValue] = useState('');
  const handleModalClose = () => { setShowModal(false); setModalRadioValue('') };
  const [fileName, setFileName] = useState('');
  const gridRef = useRef(null);
  const[planningModal,setPlanningModal] = useState(false);
  const gridRefs = {
    Active: useRef(null),
    Archived: useRef(null),
  };
  const [gridData, setGridData] = useState({
    Active: [
      { shipment_number: 'jgjhg', take_in: 'kjhjk', ttl_pcs: 'jhgjhk', ttl_weight: '54', location: 'hgf' },
    ],
    Archived: [
      { shipment_number: 'jgjhg', take_in: 'kjhjk', ttl_pcs: 'jhgjhk', ttl_weight: '54', location: 'hgf' },
    ],
    // Trash: []

  });
  useEffect(() => {
    if (isMounted.current) return;
    setIsLoading(false);
    setGridData({ Active: {} });
    isMounted.current = true;
  }, []);

  const [formData, setFormData] = useState(
    {
      id: '1',
      status: '',
      destination: '', handler_name: '',
      // condition_code: '', type_code: '', serial_number: '', owner_code: '', airline_name: '', asset_type: false,
      uldInfo: [
        { id: '1', type_code: '', serial_number: '', owner_code: '', condition_code: 'SER', airline_name: '', asset_type: '', }
      ]
    }
  );


  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);


  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }
  }
  const [checksModalType, setChecksModalType] = useState("checks");
  const [showChecksModal, setShowChecksModal] = useState(false);
  const [checksFormData, setChecksFormData] = useState({});
  const [checksRecordId, setChecksRecordId] = useState(null);
  const [isLoadingChecks, setIsLoadingChecks] = useState(false);
   const openChecksModal = async (id, type = "checks") => {
      setChecksModalType(type);
      setChecksRecordId(id);
      setShowChecksModal(true);
      setIsLoadingChecks(true);
      try {
        const res = await withRFSToken.post(`shipment/export-shipment-record-details/${id}`, {});
        if (res.data.response_code === 200) {
          const innerData = res.data.response_data;
          setChecksFormData({ ...innerData });
        } else {
          toast.error(res.data.response_msg || "Failed to load checks data");
        }
      } catch (error) {
        console.error("Error fetching checks data:", error);
        toast.error("Failed to load checks data");
      } finally {
        setIsLoadingChecks(false);
      }
    };
    const closeChecksModal = () => {
    setShowChecksModal(false);
    setChecksFormData({});
    setChecksRecordId(null);
    // setChecksModalType('checks'); // Reset to default
  };
  const handleChecksInputChange = (name, value) => {
    if (name === "pick_up_check") {
      if (value === "1") {
        const now = new Date();
        const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
        setChecksFormData({
          ...checksFormData,
          pick_up_check: value,
          pick_up: formattedDate,
        });
      } else {
        setChecksFormData({
          ...checksFormData,
          pick_up_check: value,
          pick_up: "",
        });
      }
      return;
    }
    if (name === "warehouse_inbound_check") {
      if (value === "1") {
        const now = new Date();
        const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
        setChecksFormData({
          ...checksFormData,
          warehouse_inbound_check: value,
          warehouse_inbound: formattedDate,
        });
      } else {
        setChecksFormData({
          ...checksFormData,
          warehouse_inbound_check: value,
          warehouse_inbound: "",
        });
      }
      return;
    }
    if (name === "screening") {
      if (value === "1") {
        const now = new Date();
        const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
        setChecksFormData({
          ...checksFormData,
          screening: value,
          screening_date: formattedDate,
          sec_status: "K"
        });
      } else {
        setChecksFormData({
          ...checksFormData,
          screening: value,
          screening_date: "",
          sec_status: "U"
        });
      }
      return;
    }
    if (name === "checks_completed_check") {
      if (value === "1") {
        const now = new Date();
        const formattedDate = now.toLocaleString("sv-SE").slice(0, 16);
        setChecksFormData({
          ...checksFormData,
          checks_completed_check: value,
          checks_completed: formattedDate,
        });
      } else {
        setChecksFormData({
          ...checksFormData,
          checks_completed_check: value,
          checks_completed: "",
        });
      }
      return;
    }
    setChecksFormData({
      ...checksFormData,
      [name]: value,
    });
  };
   const handleChecksSave = async () => {
      try {
        const res = await withRFSToken.post(
          "shipment/save-export-shipment-record",
          checksFormData
        );
        if (res.data.response_code === 200) {
          toast.success(res.data.response_msg || "Checks updated successfully");
          closeChecksModal();
          // Refresh the grid
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
        } else {
          toast.error(res.data.response_msg || "Failed to update checks");
        }
      } catch (error) {
        console.error("Error saving checks:", error);
        toast.error("Failed to update checks");
      }
    };

  let checkUlds = [];
  let filterForCheck = false;

  useEffect(() => {
    if (gridRefs[activeTab]?.current) {
      // if (gridData[activeTab]) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      let tabType = '';
      if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'cutt_off_date', type: 'date' },
          { name: 'airway_bill', type: 'string' },
          { name: 'uld_no', type: 'string' },
          { name: 'picklist', type: 'string' },
          { name: 'pick_status', type: 'string' },
          { name: 'shipment_type', type: 'string' },
          { name: 'shipment_status', type: 'string' },
          { name: 'trip_number', type: 'string' },
          { name: 'trip_status', type: 'string' },
          { name: 'ttl_pcs', type: 'string' },
          { name: 'ttl_weight', type: 'string' },
          { name: 'linked', type: 'string' },
          { name: 'origin', type: 'string' },
          { name: 'destination', type: 'string' },
          { name: 'bkd', type: 'string' },
          { name: 'rcs', type: 'string' },
          { name: 'dep', type: 'string' },
          { name: 'flight', type: 'string' },
          { name: 'package', type: 'string' },
          { name: 'customs', type: 'string' },
          { name: 'special_handling_code', type: 'string' },
          { name: 'security', type: 'string' },
          { name: 'check_status_color', type: 'string' },
          { name: 'screening', type: 'string' },
          { name: 'sec_status', type: 'string' },
          { name: "ground_handler", type: "string" },
        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}shipment-export/outbound-list?type=${tabType}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        // localdata: gridData[activeTab],
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


          // setTimeout(() => {
          //     const rows = window.$(gridRef.current).jqxGrid('getrows');

          //     console.log("rows", rows);
          //     (checkUlds).forEach(uldNumber => {
          //         console.log(checkUlds);
          //         rows.forEach((element, index) => {
          //             if (element.uld_number == uldNumber) {
          //                 window.$(gridRef.current).jqxGrid('selectrow', index);
          //             }
          //         });
          //     });
          // }, 4000);
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          setTotalRows({ totalUlds: data.activeCount });
          setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        // {
        //   text: 'Actions',
        //   cellsrenderer: function () {
        //     return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
        //   },
        //   width: '5%', filterable: false,
        // },
        { text: 'LAT', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'cutt_off_date', width: '6%', cellclassname: '', },
        { text: 'Airway Bill', filtertype: 'input', datafield: 'airway_bill', width: '6%', cellclassname: '', },
        { text: 'ULD No', filtertype: 'input', datafield: 'uld_no', width: '6%', cellclassname: '', },
        //{ text: 'Picklist', filtertype: 'textbox', datafield: 'picklist', width: '8%', cellclassname: '', },
        {
          text: 'Picklist', datafield: 'picklist', width: '5%', filterable: false,
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
              defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
            }
            return (
              defaultHtml
            );
          },
        },
        {
          text: 'Pick Status', filtertype: 'checkedlist', datafield: 'pick_status', width: '8%',
          filteritems: [
            { label: 'Open', value: 'Open' },
            { label: 'Progress', value: 'Progress' },
            { label: 'Complete', value: 'Complete' },
            { label: 'Incomplete', value: 'Incomplete' },
          ],
          cellclassname: (row, column, value, rowData, cellvalue) => {
            // console.log("🚀 ~ useEffect ~ rowData:", rowData)
            if (rowData.pick_status == 'Complete') {
              return "awb_green";
            } else if (rowData.pick_status == 'Incomplete') {
              return "awb_red";
            } else if (rowData.pick_status == 'Progress') {
              return "awb_orange";
            } else if (rowData.pick_status == 'Open') {
              return "awb_blue";
            } else if (rowData.pick_status == 'Initiated') {
              return "awb_sky";
            } else {
              return;
            }
          },
        },
        { text: "Ground Handler", filtertype: "input", datafield: "ground_handler", width: "10%", cellclassname: "", },
        { text: 'Shipment Type', filtertype: 'input', datafield: 'shipment_type', width: '7%', cellclassname: '', },
        { text: ' TTL Pcs', filtertype: 'input', datafield: 'ttl_pcs', width: '7%', cellclassname: '', },
        { text: ' TTL Weight', filtertype: 'input', datafield: 'ttl_weight', width: '7%', cellclassname: '', },
        { text: "Linked",datafield: "linked", filtertype: "input", width: "4%", cellclassname: "",
              cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                const rowCount = rowData?.linked ?? '';
                if(rowCount == 0) {return ""}
                return `<div style="margin-top:13px;margin-left:10px; cursor: pointer; color: green;" class="">
                ${rowCount}
                </div>`;
              },
            },
        { text: 'Destination', filtertype: 'input', datafield: 'destination', width: '7%', cellclassname: '', },
        // { text: 'Shipment Status', filtertype: 'input', datafield: 'shipment_status', width: '8%', cellclassname: '', },
        // { text: 'Trip Number', filtertype: 'input', datafield: 'trip_number', width: '8%', cellclassname: '', },
        // { text: 'Trip Status', filtertype: 'input', datafield: 'trip_status', width: '7%', cellclassname: '', },
        { text: 'Origin', filtertype: 'input', datafield: 'origin', width: '7%', cellclassname: '', },
        // { text: 'BKD', filtertype: 'input', datafield: 'bkd', width: '8%', cellclassname: '', },
        // { text: 'RCS', filtertype: 'input', datafield: 'rcs', width: '8%', cellclassname: '', },
        // { text: 'DEP', filtertype: 'input', datafield: 'dep', width: '8%', cellclassname: '', },
        // { text: 'Flight', filtertype: 'input', datafield: 'flight', width: '8%', cellclassname: '', },
        // { text: 'Package', filtertype: 'input', datafield: 'package', width: '8%', cellclassname: '', },
        // { text: 'Customs', filtertype: 'input', datafield: 'customs', width: '8%', cellclassname: '', },
        // { text: 'Special Handling Code', filtertype: 'input', datafield: 'special_handling_code', width: '8%', cellclassname: '', },
        // { text: 'Security', filtertype: 'input', datafield: 'security', width: '8%', cellclassname: '', },
         {
           text: "Checks", datafield: "check_status_color", filterable : false, width: "5%", cellclassname: "checks-clickable",
            cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
              const iconMap = {
                grey: greycheck,
                green: greencheck,
                orange: orangecheck,
              };
              const iconSrc = iconMap[cellValue];
              const rowId = rowData?.id || rowData?.bounddata?.id || "";
              return iconSrc
                ? `<div style="margin-top:13px;margin-left:10px;" class="checks-cell" data-row-id="${rowId}">
                              <img src="${iconSrc}" alt="${cellValue}" style="width:16px; height:16px;" />
                          </div>`
                : "";
            },
          },
          // {
          //   text: "Screening", datafield: "screening",  filterable : false, width: "5%", cellclassname: "screening-clickable",
          //   cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
          //     const rowId = rowData?.id || rowData?.bounddata?.id || "";
          //     const iconSrc = cellValue === "1" ? screeninggreen : screeninggrey;
          //     return `<div style="margin-left:10px; margin-top:13px; " class="screening-cell" data-row-id="${rowId}">
          //                     <img src="${iconSrc}" alt="${cellValue}" style="width:16px; height:16px;" />
          //                 </div>`;
          //   },
          // },
          {
            text: "Security", datafield: "sec_status",  filterable : false, width: "5%", cellclassname: "sec-status-clickable",
            cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
              const rowId = rowData?.id || rowData?.bounddata?.id || "";
              const iconSrc = cellValue === "K" ? securitygreen : securityred;
              return `<div style="margin-left:10px; margin-top:13px;" class="sec-status-cell" data-row-id="${rowId}">
                              <img src="${iconSrc}" alt="${cellValue}" style="width:16px; height:16px;" />
                          </div>`;
            },
          },

      ];
      const nestedColumns = [
        { text: 'Take In', datafield: 'take_in', width: '8%' },
        { text: 'HAWB', datafield: 'hawb', width: '7%' },
        // {
        //   text: 'Receipt', datafield: 'receipt', width: '6%',

        //   cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
        //     if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
        //       defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
        //     }
        //     return (
        //       defaultHtml
        //     );
        //   },
        // },
        { text: 'PCS', datafield: 'pieces', width: '4%' },
        { text: 'PCS Picked', datafield: 'pcs_picked', width: '6%' },
        {
          text: 'Pick Status', filtertype: 'checkedlist', datafield: 'pick_status', width: '6%',
          filteritems: [
            { label: 'Open', value: 'Open' },
            { label: 'Progress', value: 'Progress' },
            { label: 'Complete', value: 'Complete' },
            { label: 'Incomplete', value: 'Incomplete' },
          ],
          cellclassname: (row, column, value, rowData, cellvalue) => {
            // console.log("🚀 ~ useEffect ~ rowData:", rowData)
            if (rowData.pick_status == 'Complete') {
              return "awb_green";
            } else if (rowData.pick_status == 'Incomplete') {
              return "awb_red";
            } else if (rowData.pick_status == 'Progress') {
              return "awb_orange";
            } else if (rowData.pick_status == 'Open') {
              return "awb_blue";
            } else if (rowData.pick_status == 'Initiated') {
              return "awb_sky";
            } else {
              return;
            }
          },
        },
        { text: 'MSCA', datafield: 'msca', width: '4%' },
        { text: 'Picked Time', datafield: 'picked_time', width: '6%' },
        { text: 'Picked Name', datafield: 'picked_name', width: '8%' },
        { text: 'ID', datafield: 'id', width: '4%' },
        { text: 'Bonded', datafield: 'bonded', width: '4%' },
        { text: 'Label', datafield: 'label', width: '8%' },
        { text: 'Shipment Number', datafield: 'shipment_number', width: '8%' },
        { text: 'Storage Location', datafield: 'storage_location', width: '8%' },
        { text: 'Destination', datafield: 'destination', width: '8%' },
      ];

      const nestedGrids = {};
      const initrowdetails = (index, parentElement, gridElement, record) => {
        const nestedGridContainer = parentElement.children[0];
        // console.log('Nested arrow clicked:', index, parentElement, gridElement, record);
        // console.log('nestedGridContainer', nestedGridContainer);

        const parentRowId = record.uid.toString();
        nestedGrids[parentRowId] = nestedGridContainer;

        parentElement.addEventListener('click', (event) => {
          const target = event.target;
          // Check if the click target is the nested arrow
          if (window.$(target).hasClass('jqx-icon-arrow-right')) {
            // Handle nested arrow click here
            // console.log('Nested arrow clicked:', record);
            event.stopPropagation(); // Prevent event bubbling to the row details
          }
        });
        console.log(dataAdapter);
        const id = record.uid.toString();
        console.log('ov >>:', dataAdapter.loadedData.Rows[id]);
        const hawbGrid = dataAdapter.loadedData.Rows[id].airway_bill;
        const subendPoint = `shipment-export/sub-outbound-list?airway_bill=${hawbGrid}`;
        const nestedSource = {
          datatype: 'json',
          id: 'shipmentChildID',
          datafields: [
            { name: 'id', type: 'string' },
            { name: 'hawb', type: 'string' },
            { name: 'take_in', type: 'string' },
            { name: 'receipt', type: 'string' },
            { name: 'pieces', type: 'string' },
            { name: 'pcs_picked', type: 'string' },
            { name: 'msca', type: 'string' },
            { name: 'picked_time', type: 'string' },
            { name: 'picked_name', type: 'string' },
            { name: 'bonded', type: 'string' },
            { name: 'label', type: 'string' },
            { name: 'shipment_number', type: 'string' },
            { name: 'storage_location', type: 'string' },
            { name: 'destination', type: 'string' },
            { name: 'pick_status', type: 'string' },
            { name: "screening", type: "string" },
            { name: "sec_status", type: "string" },
            { name: "check_status_color", type: "string" },
          ],
          // localdata: uldGrid,
          url: `${process.env.REACT_APP_RFS_URL}${subendPoint}`,
          // beforeSend: function (jqXHR) {
          //   jqXHR.setRequestHeader('Authorization', token);
          // },
          // localdata: gridData[activeTab],
          pagesize: 50,
          filter: function (allfilters) {
            if (allfilters.length > 0) {
              setFilterApplied(true);
              filterForCheck = true;
            } else {
              setFilterApplied(false);
              filterForCheck = false;
            }
            window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


            // setTimeout(() => {
            //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

            //     console.log("rows", rows);
            //     (checkUlds).forEach(uldNumber => {
            //         console.log(checkUlds);
            //         rows.forEach((element, index) => {
            //             if (element.uld_number == uldNumber) {
            //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
            //             }
            //         });
            //     });
            // }, 4000);
          },
          beforeprocessing: function (data) {
            source.totalrecords = data.TotalRows;
            setTotalRows({ totalUlds: data.activeCount });
            setTotalRowsR({ totalUlds: data.archiveCount });
          },
          sort: function () {
            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
          },
          root: "Rows",
          cache: false,
        }

        const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

        const nestedGridOptions = {
          width: '100%',
          pageable: false,
          sortable: false,
          // pageSize: 15,
          autoheight: false,
          height: (10 * 45),
          selectionmode: 'none', // checkbox
          source: nestedDataAdapter,
          filterable: false,
          columns: nestedColumns,
          rowdetails: true,
          rowsheight: 45,
          showemptyrow: false,
          ready: function () {
            // Manually set row IDs starting from 0
            const rows = window.$(nestedGridContainer).jqxGrid('getrows');
            for (let i = 0; i < rows.length; i++) {
              const rowid = i; // Use index as the new row ID
              const row = rows[i];
              window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
              window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
              window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
            }
          },
        };
        window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
      };
      // Nested End
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 50,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        initrowdetails: initrowdetails,
        rowdetails: true,
        rowdetailstemplate: {
          rowdetails: '<div id="nestedGrids" style="margin: 10px;"></div>',
          rowdetailsheight: (10 * 45),
          // rowdetailshidden: true,
        },
        rendergridrows: function (params) {
          return params.data;
        },

         ready: function () {
          const filtergroup = new window.$.jqx.filter();
          const or_operator = 1; 
          const defaultCheckedValues = ['Open', 'Progress', 'Incomplete', 'Initiated'];

          defaultCheckedValues.forEach((val) => {
            const filter = filtergroup.createfilter('stringfilter', val, 'EQUAL');
            filtergroup.addfilter(or_operator, filter);
          });

          window.$(gridRefs[activeTab].current).jqxGrid('addfilter', 'pick_status', filtergroup);
          window.$(gridRefs[activeTab].current).jqxGrid('applyfilters');
        },

        // rendered: function () {
        //   const rows = window.$(gridRef.current).jqxGrid('getrows');
        //   (checkUlds).forEach(uldNumber => {
        //     rows.forEach((element, index) => {
        //       if (element.uld_number == uldNumber) {
        //         window.$(gridRef.current).jqxGrid('selectrow', index);
        //       }
        //     });
        //   });
        // }
      };
      window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
        const dataToSend = {
          uld_number: rowData.uld_number,
          type_code: rowData.type_code,
          serial_number: rowData.serial_number,
          owner_code: rowData.owner_code,
          condition_code: rowData.condition_code,
          asset_type: rowData.asset_type == 'Y' ? false : true
        };
        // setEditData(dataToSend);
        // setShowEdit(true);
      });
      window.$(gridRefs[activeTab].current).on('click', '.screen', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
        console.log("🚀 ~ rowData:", rowData)
        // setIsModal(true)
      });
      window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.airway_bill;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }
          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.airway_bill === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRef.current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.airway_bill;
          setGridSelect(prevSelection => prevSelection.filter(row => row.airway_bill !== unselectedRowId));
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
        }
      });
      window.$(gridRefs[activeTab].current).off('cellclick');
      window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (event.args.columnindex > 0 && ![5, 13, 14, 15].includes(event.args.columnindex)) {
          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
          }
          // loadDetails(args.uld_number);
          setSelectedRowData(args)
          setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
          }, 30);
        }
      });
      // }
    }
  }, [gridData]);

  const loadDetails = async (uldNumber) => {
    // try {
    //     const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
    //         .then(function (res) {
    //             const innerData = res.data.response_data;
    //             // console.log("🚀 ~ .then ~ innerData:654", innerData)
    //             setSelectedRowData(innerData);

    //         });
    // } catch (error) {
    //     console.error('Error fetching data:', error);
    // }
  }
  const handleCloseClick = () => {
    setSelectedRowData(null);
    setTimeout(() => {
      window.$(gridRefs[activeTab].current).jqxGrid('refresh');
    }, 30);
  };

  const [galleryOpen, setGalleryOpen] = useState(false);
  const showGalleryModal = () => {
    setGalleryOpen(true);
  };
  const closeGalleryModal = () => {
    setGalleryOpen(false);
  };

  // upload Section
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);

  // const imageModalUpload = (id) => {
  //     setSelectedRowId(id);
  //     setShowModalUpload(true)
  //     setFiles([])
  // }
  const imageModalUpload = (id) => {
    const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id); // Store the ID of the selected row
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  // const handleFileChange = (e) => {
  //     const selectedFiles = Array.from(e.target.files);
  //     const filesWithBase64 = [];
  //     selectedFiles.forEach((file) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //             filesWithBase64.push({ file, base64: reader.result });
  //             if (filesWithBase64.length === selectedFiles.length) {
  //                 setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);

  //             }
  //         };
  //         reader.readAsDataURL(file);
  //     });
  // }
  // const handleFileChange = (e) => {
  //   const selectedFiles = Array.from(e.target.files);
  //   const filesWithBase64 = [];

  //   selectedFiles.forEach((file) => {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

  //       if (filesWithBase64.length === selectedFiles.length) {
  //         setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
  //         setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
  //       }
  //     };
  //     reader.readAsDataURL(file);
  //   });
  // };
  const handleFileChange = (event) => {
    // console.log("🚀 ~ handleFileChange ~ event:", event)
    setSelectedFile(event.target.files[0]);

    const input = event.target;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      setFileName(file.name);
      setSelectedFile(file);
    }
    const selectedFiles = Array.from(event.target.files);
    const filesWithBase64 = [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

        if (filesWithBase64.length === selectedFiles.length) {
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
        }
      };
      reader.readAsDataURL(file);
    });
  };
  const imageUpload = () => {
    setGridSelect(prevGridSelect =>
      prevGridSelect.map(item => {
        if (item.uid === selectedRowId) {
          return { ...item, files: files, base64Files: base64Files };
        }
        return item;
      })
    );
    setShowModalUpload(false);
  };
  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };

  // +++++++++++++++++++++++++++++++++++ Silk Slider
  const findPrimary = selectedRowData?.attachments?.filter((attachment) => attachment.primary === 1);
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedFile('');
  };

  const createCargo = () => {
    localStorage.setItem('ccbackUrl', '/ForwarderShipments/Export');
    history.push('/ForwarderShipments/CreateCargo');
  }

  //---------------- upload data files start------------------------>
  const handleModalOpen = (contentType) => {
    setModalContent(contentType);
    setShowModal(true);
  };

  const handleConfirmation = (confirm) => {
    if (confirm) {
      setShowModal(false);
      history.push('/ULDControl');
    } else {
      setShowModal(false);
    }
  }

  const handleModalRadioChange = (event) => {
    const { name, value } = event.target;
    setModalRadioValue({ [name]: value });
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file first!");
      return;
    }
    // setUploading(true);
    // console.log('300', selectedFile);
    // console.log('301', base64Files[0]);

    if (selectedFile) {
      try {
        const res = await withRFSToken.post('shipment-export/upload-planning-data', { excelData: base64Files[0] });
        if (res.data.responseCode == 1) {
          toast.success('File uploaded successfully!');
          setTimeout(() => {
            setIsLoading(false);
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
          }, 1);
        }
      } catch (error) {
        console.error("There was an error uploading the file!", error);
      } finally {
        setShowModal(false);
      }
    }
  };

  const handleModalUpdate = () => {
    const updatedAssetType = modalRadioValue.assetType === 'O' ? false : true;
    const updatedFormData = {
      ...formData,
      asset_type: updatedAssetType,
      uldInfo: formData.uldInfo.map(stack => ({
        ...stack,
        asset_type: updatedAssetType
      }))
    };
    setFormData(updatedFormData);
    setModalRadioValue('')
    setShowModal(false);
  };

  const handleDownloadClick = () => {
    const a = document.createElement('a');
    a.href = XLSFILE;
    a.download = 'outbound_template.xls'; // Name for the downloaded file
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  const openPlanningModal = () => {
    if(gridSelect?.length > 0){
      const allComplete = gridSelect.every(item => item.pick_status === "Complete");
      if (allComplete) {
          setPlanningModal(true);
        } else {
          toast.error(`Selected ${gridSelect.length > 1 ? "records are" : "record is"} not complete`);
        }
    }else {
      toast.error("You must select at least one record before proceeding.")
    }
  }
  const handlePlanningResponse = async (confirm) => {
    if (confirm) {
      console.log("reached here");
      const payload = gridSelect.map(e => e.airway_bill);
      if(payload){
        try {
          const res = await withRFSToken.post('shipment-export/move-to-planning', {awbId: payload});
          if (res.data.response_code == 200) {
            toast.success(res.data.response_msg);
            setGridSelect([]);
            window.$(gridRefs[activeTab].current).jqxGrid("clearselection");
            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
          }
        }catch (error) {
          // toast.error(error?.response?.data?.message || 'Something went wrong!');
          toast.error('Something went wrong!');
        }
      }

    } else {
      handlePlanningModalClose();      
    }
    handlePlanningModalClose();     
  };
  const handlePlanningModalClose = () => {
    setPlanningModal(false);
  }

  const [actArcModal, setActArcModal] = useState(false);
  const handleMoveToActArc = () => {
    if (gridSelect.length <= 0) {
      toast.error('Please select grid data before send');
    } else {
      setActArcModal(true);
      // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
    }
  };
  const confirmMoveToActArc = async () => {
      // console.log('101', gridSelect);
      const sendAction = activeTab == 'Active' ? 'R' : 'A';
      const uldNumbers = gridSelect && gridSelect.map(num => num.id)
      try {
        const res = await withRFSToken.post('shipment-export/move-shipment-to-archive', { shipmentId: uldNumbers })
          .then(function (res) {
            if (res.data.response_code == 200) {
              gridSelect.forEach(item => {
                const selectedRowBoundIndex = item.boundindex;
                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
              });
              window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
              setActArcModal(false)
            }
          });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  
    const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    // gridSelect.forEach(item => {
    //     const selectedRowBoundIndex = item.boundindex;
    //     window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
    // });
    // setGridSelect([]);
  };

  return (
    <>
    {console.log("gridSelect",gridSelect)}
      {galleryOpen && <GalleryView attachments={selectedRowData.attachments} attachment_sec='oa' onClose={closeGalleryModal} />}
      <div className="mb-3 nestedtabs rounded minh">
        <div className='d-flex'>
          {/* <button className="addtruck me-2" variant="primary" onClick={createCargo}>
            <span> <FontAwesomeIcon icon={faPlus} /> Create Cargo</span>
          </button> */}
          {/* <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
              <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'In Operation')}>Option One</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDropdownItemClick('On Air')}>On Air</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair In')}>Option Two</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
          {/* <span className="selected">
            Selected Row <Badge>{gridSelect.length}</Badge>
          </span> */}
        </div>

        <div className='d-flex'>
              <Dropdown>
                <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                    <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => openPlanningModal()}>Move To Planning</Dropdown.Item> 
                </Dropdown.Menu>
            </Dropdown>
            <div className='ulddown'>
            <button onClick={() => handleModalOpen('import')} ><img src={Export} /> Upload Data</button>
            <button onClick={() => handleMoveToActArc()}> <img title='' src={Arcv} />{activeTab === 'Active' ? 'Archive' : 'Active'}</button>
          </div>
        </div>
      </div>
      <div className="maindiv">
        <div className='trashdonload'>
          <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
            <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
              {/* <Loader isLoading={isLoading} /> */}
              {/* {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.Active} className='bookinggrid' ></div>
              </>
              } */}
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <div ref={gridRefs.Active} className='bookinggrid' ></div>}
            </Tab>
            <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}

            </Tab>
          </Tabs>
        </div>
        {selectedRowData && (
          <div className='SecondDiv mt-45'>
            {/* {console.log('55', selectedRowData)} */}
            <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
            <div className='girddtals_header'>
              <h3>
                {selectedRowData.airway_bill} &nbsp; <span>{selectedRowData.status}</span>
              </h3>
              <div className='d-flex actbtn'>
                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
              </div>

            </div>
            <div className='mt-3'>
              <div className='mb-3'>
                <h3>Highlighted Image(s)</h3>
                {selectedRowData?.attachments && (
                  <>
                    <div className="g_parent">
                      {findPrimary.slice(0, 5).map((file, index) => {
                        let classN = '';
                        if (findPrimary.length === 1) {
                          classN = 'double'
                        } else if (findPrimary.length === 2) {
                          classN = 'double'
                        } else if (findPrimary.length === 3) {
                          classN = 'third'
                        } else if (findPrimary.length > 3) {
                          classN = 'more'
                        }
                        return (
                          <>
                            <div className={`${classN}${index + 1}`}>
                              <img
                                src={file.file_path}
                                alt="Preview"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",

                                }}

                                // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                onClick={() =>
                                  handleFileClick(file.file_path)
                                }
                              />
                            </div>
                          </>
                        )
                      })}
                      {findPrimary.length > 5 && (
                        <div className='more'>
                          <button className="more-btn" onClick={showGalleryModal}>
                            +{findPrimary.length - 5}
                          </button>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>

            <ImageUpload
              ref={imageUploadRef}
              attachable_type={"outbound"}
              attachable_id={selectedRowData.awbId}
              attachments={selectedRowData.attachments}
              onDeleteSuccess={() => loadDetails(selectedRowData.awbId)}
            />
            <ActivityComments
              commentable_type={"outbound"}
              commentable_id={selectedRowData.awbId}
              allactivities={selectedRowData.activities}
              onReloadDetails={loadDetails}
            />
          </div>
        )}
      </div>

      <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          {modalContent === 'import' && (
            <>
              <h3>Import Excel</h3>
              <p>Upload the filled in template to add ULDs.</p>
              <div className='asset_midle'>

                <div className='upload_tmpl'>
                  <button onClick={handleDownloadClick}>
                    <FontAwesomeIcon icon={faDownload} />
                    <span>Download Template (Excel) </span>
                  </button>
                  <div className="form-group inputDnD">
                    <FontAwesomeIcon icon={faUpload} />
                    <input
                      type="file" className="form-control-file "
                      id="inputFile"
                      // accept=".xlsx, .xls, .csv"
                      onChange={handleFileChange}
                      data-title="Upload your file (Excel)" />

                    {/* {fileData && (
                                                <div>
                                                    <h4>File Data:</h4>
                                                    <pre>{fileData}</pre>
                                                </div>
                                            )} */}
                  </div>
                </div>

                {fileName && (
                  <div className='rafilname'>
                    <p>File Name: {fileName}</p>
                  </div>
                )}


                {/* <Form.Control
                                        type="file"
                                        onChange={handleFileChange}
                                        accept=".xlsx, .xls, .csv"
                                    /> */}
              </div>
            </>
          )}
          {modalContent === 'cancelForm' && (
            <>
              <h3>All changes will be destroyed.</h3>
              <p>If you proceed with the change, all data in this section will be removed.
                Are you sure you want to continue?</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {modalContent === 'import' ? (
            <>
              <div className='d-flex w-50 mx-auto are_bottom'>
                <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleUpload}>
                  Upload
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className='d-flex w-50 mx-auto are_bottom'>
                <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                  No
                </Button>
                <Button variant="primary" onClick={() => handleConfirmation(true)}>
                  Yes
                </Button>
              </div>
            </>
          )}
        </Modal.Footer>
      </Modal>

       <Modal show={planningModal} onHide={handlePlanningModalClose} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
           <h3>Selected items will be moved to the Planning tab.</h3>
            <p>Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
            <>
              <div className='d-flex w-50 mx-auto are_bottom'>
                <Button variant="secondary" onClick={() => handlePlanningResponse(false)}>
                  No
                </Button>
                <Button variant="primary" onClick={() => handlePlanningResponse(true)}>
                  Yes
                </Button>
              </div>
            </>
          
        </Modal.Footer>
      </Modal>   
      <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered >
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            <h3>Selected {gridSelect.length > 1 ? "Shipment's" : 'Shipment'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
            <p>Are you sure you want to move {gridSelect.length > 1 ? "Shipment's" : 'Shipment'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p>
          </Modal.Body>
          <Modal.Footer>
            <div className='d-flex w-50 mx-auto are_bottom'>
              <Button variant="secondary" onClick={() => setActArcModal(false)}>
                No
              </Button>
              <Button variant="primary" onClick={confirmMoveToActArc}>
                Yes
              </Button>
            </div>
          </Modal.Footer>
        </Modal> 
              <Modal
                className="addfrom change_type"
                show={showChecksModal}
                onHide={closeChecksModal}
                centered
                size={checksModalType === "sec_status" ? "md" : "lg"}
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {checksModalType === "checks"
                      ? "Checks"
                      : checksModalType === "screening"
                        ? "Screening"
                        : "Security Status"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {isLoadingChecks ? (
                    <div className="text-center p-4">Loading...</div>
                  ) : (
                    <div className="flbg details h-100 record_export_modal">
                      <ul className="checks">
                        {/* Show only Screening field when screening modal type */}
                        {checksModalType === "screening" && (
                          <li>
                            <span className="d-flex align-items-base-line justify-content-between gap-3">
                              <span style={{ minWidth: "180px", color: "inherit" }}>
                                Screening :
                              </span>
                              <span className="d-flex" style={{ minWidth: "220px" }}>
                                <Form.Check
                                  inline
                                  type="radio"
                                  label="Yes"
                                  name="screening"
                                  checked={checksFormData.screening == "1"}
                                  onChange={() =>
                                    handleChecksInputChange("screening", "1")
                                  }
                                />
                                <Form.Check
                                  inline
                                  type="radio"
                                  label="No"
                                  name="screening"
                                  checked={checksFormData.screening == "0"}
                                  onChange={() =>
                                    handleChecksInputChange("screening", "0")
                                  }
                                />
                              </span>
                              <Form.Control
                                type="datetime-local"
                                name="screening_date"
                                value={checksFormData?.screening_date || ""}
                                onChange={(e) =>
                                  handleChecksInputChange(
                                    "screening_date",
                                    e.target.value
                                  )
                                }
                                style={{ maxWidth: "230px" }}
                                className="date_picker"
                              />
                            </span>
                          </li>
                        )}
        
                        {/* Show only Sec Status field when sec_status modal type */}
                        {checksModalType === "sec_status" && (
                          <li className="">
                            <span className="d-flex align-items-base-line justify-content-between gap-3">
                              <span style={{ minWidth: "170px", color: "inherit" }}>
                                Security Status :
                              </span>
                              <span className="d-flex" style={{ minWidth: "220px" }}>
                                <Form.Check
                                  inline
                                  type="radio"
                                  label="Known"
                                  id="Known-1"
                                  name="sec_status"
                                  value="K"
                                  checked={checksFormData?.sec_status === "K"}
                                  onChange={(e) =>
                                    handleChecksInputChange("sec_status", "K")
                                  }
                                />
                                <Form.Check
                                  inline
                                  type="radio"
                                  label="Unknown"
                                  id="Known-2"
                                  name="sec_status"
                                  value="U"
                                  checked={checksFormData?.sec_status === "U"}
                                  onChange={(e) =>
                                    handleChecksInputChange("sec_status", "U")
                                  }
                                />
                              </span>
                            </span>
                          </li>
                        )}
        
                        {/* Show all fields for checks modal type */}
                        {checksModalType === "checks" && (
                          <>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  Pick Up :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    name="pick_up_check"
                                    checked={checksFormData.pick_up_check == "1"}
                                    onChange={() =>
                                      handleChecksInputChange("pick_up_check", "1")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    name="pick_up_check"
                                    checked={checksFormData.pick_up_check == "0"}
                                    onChange={() =>
                                      handleChecksInputChange("pick_up_check", "0")
                                    }
                                  />
                                </span>
                                <Form.Control
                                  type="datetime-local"
                                  name="pick_up"
                                  value={checksFormData?.pick_up || ""}
                                  onChange={(e) =>
                                    handleChecksInputChange("pick_up", e.target.value)
                                  }
                                  style={{ maxWidth: "230px" }}
                                  className="date_picker"
                                />
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  Warehouse Inbound :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    name="warehouse_inbound_check"
                                    checked={
                                      checksFormData.warehouse_inbound_check == "1"
                                    }
                                    onChange={() =>
                                      handleChecksInputChange(
                                        "warehouse_inbound_check",
                                        "1"
                                      )
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    name="warehouse_inbound_check"
                                    checked={
                                      checksFormData.warehouse_inbound_check == "0"
                                    }
                                    onChange={() =>
                                      handleChecksInputChange(
                                        "warehouse_inbound_check",
                                        "0"
                                      )
                                    }
                                  />
                                </span>
                                <Form.Control
                                  type="datetime-local"
                                  name="warehouse_inbound"
                                  value={checksFormData?.warehouse_inbound || ""}
                                  onChange={(e) =>
                                    handleChecksInputChange(
                                      "warehouse_inbound",
                                      e.target.value
                                    )
                                  }
                                  style={{ maxWidth: "230px" }}
                                  className="date_picker"
                                />
                              </span>
                            </li>
                            <li className="">
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  Security Status :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Known"
                                    id="Known-1"
                                    name="sec_status"
                                    value="K"
                                    checked={checksFormData?.sec_status === "K"}
                                    onChange={(e) =>
                                      handleChecksInputChange("sec_status", "K")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Unknown"
                                    id="Known-2"
                                    name="sec_status"
                                    value="U"
                                    checked={checksFormData?.sec_status === "U"}
                                    onChange={(e) =>
                                      handleChecksInputChange("sec_status", "U")
                                    }
                                  />
                                </span>
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  Screening :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    name="screening"
                                    checked={checksFormData.screening == "1"}
                                    onChange={() =>
                                      handleChecksInputChange("screening", "1")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    name="screening"
                                    checked={checksFormData.screening == "0"}
                                    onChange={() =>
                                      handleChecksInputChange("screening", "0")
                                    }
                                  />
                                </span>
                                <Form.Control
                                  type="datetime-local"
                                  name="screening_date"
                                  value={checksFormData?.screening_date || ""}
                                  onChange={(e) =>
                                    handleChecksInputChange(
                                      "screening_date",
                                      e.target.value
                                    )
                                  }
                                  style={{ maxWidth: "230px" }}
                                  className="date_picker"
                                />
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  Customs Document :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    id="customs_document-1"
                                    name="customs_document"
                                    value="true"
                                    checked={checksFormData?.customs_document === "1"}
                                    onChange={(e) =>
                                      handleChecksInputChange("customs_document", "1")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    id="customs_document-2"
                                    name="customs_document"
                                    value="false"
                                    checked={checksFormData?.customs_document === "0"}
                                    onChange={(e) =>
                                      handleChecksInputChange("customs_document", "0")
                                    }
                                  />
                                </span>
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  Ex-a Prepared :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    id="exa_prepared_by_kerry-1"
                                    name="exa_prepared_by_kerry"
                                    value="true"
                                    checked={
                                      checksFormData?.exa_prepared_by_kerry === "1"
                                    }
                                    onChange={(e) =>
                                      handleChecksInputChange(
                                        "exa_prepared_by_kerry",
                                        "1"
                                      )
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    id="exa_prepared_by_kerry-2"
                                    name="exa_prepared_by_kerry"
                                    value="false"
                                    checked={
                                      checksFormData?.exa_prepared_by_kerry === "0"
                                    }
                                    onChange={(e) =>
                                      handleChecksInputChange(
                                        "exa_prepared_by_kerry",
                                        "0"
                                      )
                                    }
                                  />
                                </span>
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  Documents :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    id="documents-1"
                                    name="documents"
                                    value="true"
                                    checked={checksFormData?.documents === "1"}
                                    onChange={(e) =>
                                      handleChecksInputChange("documents", "1")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    id="documents-2"
                                    name="documents"
                                    value="false"
                                    checked={checksFormData?.documents === "0"}
                                    onChange={(e) =>
                                      handleChecksInputChange("documents", "0")
                                    }
                                  />
                                </span>
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  AWB Instruction :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    id="awb_instruction-1"
                                    name="awb_instruction"
                                    value="true"
                                    checked={checksFormData?.awb_instruction === "1"}
                                    onChange={(e) =>
                                      handleChecksInputChange("awb_instruction", "1")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    id="awb_instruction-2"
                                    name="awb_instruction"
                                    value="false"
                                    checked={checksFormData?.awb_instruction === "0"}
                                    onChange={(e) =>
                                      handleChecksInputChange("awb_instruction", "0")
                                    }
                                  />
                                </span>
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  AWB Draft Send :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    id="awb_draft_send-1"
                                    name="awb_draft_send"
                                    value="true"
                                    checked={checksFormData?.awb_draft_send === "1"}
                                    onChange={(e) =>
                                      handleChecksInputChange("awb_draft_send", "1")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    id="awb_draft_send-2"
                                    name="awb_draft_send"
                                    value="false"
                                    checked={checksFormData?.awb_draft_send === "0"}
                                    onChange={(e) =>
                                      handleChecksInputChange("awb_draft_send", "0")
                                    }
                                  />
                                </span>
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  AWB Approved :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    id="awb_approved-1"
                                    name="awb_approved"
                                    value="true"
                                    checked={checksFormData?.awb_approved === "1"}
                                    onChange={(e) =>
                                      handleChecksInputChange("awb_approved", "1")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    id="awb_approved-2"
                                    name="awb_approved"
                                    value="false"
                                    checked={checksFormData?.awb_approved === "0"}
                                    onChange={(e) =>
                                      handleChecksInputChange("awb_approved", "0")
                                    }
                                  />
                                </span>
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  Pre-Alert Send :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    id="pre_alert_send-1"
                                    name="pre_alert_send"
                                    value="true"
                                    checked={checksFormData?.pre_alert_send === "1"}
                                    onChange={(e) =>
                                      handleChecksInputChange("pre_alert_send", "1")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    id="pre_alert_send-2"
                                    name="pre_alert_send"
                                    value="false"
                                    checked={checksFormData?.pre_alert_send === "0"}
                                    onChange={(e) =>
                                      handleChecksInputChange("pre_alert_send", "0")
                                    }
                                  />
                                </span>
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  FWB + FHL :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    id="fwb_fhl-1"
                                    name="fwb_fhl"
                                    value="true"
                                    checked={checksFormData?.fwb_fhl === "1"}
                                    onChange={(e) =>
                                      handleChecksInputChange("fwb_fhl", "1")
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    id="fwb_fhl-2"
                                    name="fwb_fhl"
                                    value="false"
                                    checked={checksFormData?.fwb_fhl === "0"}
                                    onChange={(e) =>
                                      handleChecksInputChange("fwb_fhl", "0")
                                    }
                                  />
                                </span>
                              </span>
                            </li>
                            <li>
                              <span className="d-flex align-items-center justify-content-between gap-3">
                                <span style={{ minWidth: "180px", color: "inherit" }}>
                                  Checks Completed :
                                </span>
                                <span className="d-flex" style={{ minWidth: "220px" }}>
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="Yes"
                                    name="checks_completed_check"
                                    checked={
                                      checksFormData.checks_completed_check == "1"
                                    }
                                    onChange={() =>
                                      handleChecksInputChange(
                                        "checks_completed_check",
                                        "1"
                                      )
                                    }
                                  />
                                  <Form.Check
                                    inline
                                    type="radio"
                                    label="No"
                                    name="checks_completed_check"
                                    checked={
                                      checksFormData.checks_completed_check == "0"
                                    }
                                    onChange={() =>
                                      handleChecksInputChange(
                                        "checks_completed_check",
                                        "0"
                                      )
                                    }
                                  />
                                </span>
                                <Form.Control
                                  type="datetime-local"
                                  name="checks_completed"
                                  value={checksFormData?.checks_completed || ""}
                                  onChange={(e) =>
                                    handleChecksInputChange(
                                      "checks_completed",
                                      e.target.value
                                    )
                                  }
                                  style={{ maxWidth: "230px" }}
                                  className="date_picker"
                                />
                              </span>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <div className="d-flex w-50 mx-auto are_bottom">
                    <Button variant="secondary" onClick={closeChecksModal}>
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      onClick={handleChecksSave}
                      disabled={isLoadingChecks}
                    >
                      Save
                    </Button>
                  </div>
                </Modal.Footer>
              </Modal>

    </>
  )
}

export default OutBound